module.exports = {"130125100":"龙州镇","130125101":"南桥镇","130125102":"上碑镇","130125103":"口头镇","130125200":"独羊岗乡","130125201":"安香乡","130125202":"只里乡","130125203":"市同乡","130125204":"翟营乡","130125205":"城寨乡","130125206":"上方乡","130125207":"玉亭乡","130125208":"北河乡","130125209":"上闫庄乡","130125210":"九口子乡","130125400":"开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130125.json
// module id = 152
// module chunks = 0